export enum AnalyticsResponseTypeEnum {
  HasWebActivity = 'hasWebActivity',
  Campaign = 'campaign',
  Response = 'response',
  Attributed = 'attributed',
  Influence = 'influenced',
  Returns = 'returns',
  Cost = 'costs',
}
